import gql from 'graphql-tag';

import recentlyEditedMainDisplayObjectFragment from './recentlyEditedMainDisplayObjectFragment';

export const recentlyEditedMainDisplayObjectsGroupedByDokkioTagFragment = gql`
  fragment recentlyEditedMainDisplayObjectsGroupedByDokkioTagFragment on RecentlyEditedMainDisplayObjectsGroupedByDokkioTag {
    dokkioClass
    dokkioTagID
    recentlyEditedMainDisplayObjects {
      ...recentlyEditedMainDisplayObjectFragment
    }
  }
  ${recentlyEditedMainDisplayObjectFragment}
`;
export default recentlyEditedMainDisplayObjectsGroupedByDokkioTagFragment;
